import { colors } from "@/utils/const";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useRouter } from "next/router";
import { useI18n } from "@/i18n/I18nProvider";

export default function NotFoundPage() {
  const router = useRouter();
  const { t } = useI18n();

  return (
    <Box
      sx={{
        m: "0 auto",
        py: { xs: 2, md: 4 },
      }}
    >
      <Box
        src="https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/errorLogo.png"
        alt="Error"
        component="img"
        sx={{
          maxWidth: { xs: "250px", lg: "500px", md: "500px", sm: "500px" },
          maxHeight: { xs: "250px", lg: "500px", md: "500px", sm: "500px" },
          display: "block",
          opacity: "50%",
          margin: "0 auto",
          width: "500px",
          height: "500px",
        }}
      />

      <Typography
        component="h5"
        variant="h5"
        sx={{
          color: colors.blue,
          fontSize: "30px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {t.errorPage.title}
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textDecoration: "none",
        }}
      >
        <Button
          aria-label="Back to Home page"
          sx={{
            color: colors.white,
            border: `1px solid ${colors.blue}`,
            backgroundColor: colors.blue,
            borderRadius: "8px",
            fontSize: "14px !important",
            textTransform: "initial",
            width: "250px",
            height: "40px",
            marginTop: "20px",
            "&:hover": {
              backgroundColor: colors.blue,
              color: colors.white,
              border: `1px solid ${colors.blue}`,
            },
            "&:disabled": {
              color: "rgba(255,255,255,0.5)",
              backgroundColor: "#AFB0B8",
              border: `1px solid #AFB0B8`,
            },
          }}
          variant="contained"
          onClick={() => router.push("/")}
        >
          {t.errorPage.Home}
        </Button>
      </Box>
    </Box>
  );
}